import React from 'react';
import { useInView } from 'react-intersection-observer';

import { PurpleGradientContainer } from '../../components/backdrops/containers';

type AboutUsShowcaseProps = {};
const AboutUsShowcase: React.FC<AboutUsShowcaseProps> = React.memo(() => {
  return (
    <div className="flex flex-col gap-4 items-center justify-center mx-auto">
      <PurpleGradientContainer className="rounded-lg p-5 md:p-[80px] text-pureWhite w-full max-w-5xl relative">
        <p className="text-2xl md:text-4xl leading-normal">
          Once upon an AI frontier, Gaspar AI was born with a vision — to streamline how employees navigate their everyday challenges and
          empower support teams to focus on impactful work. Our journey is fueled by a commitment to simplify complexities, automate tasks,
          and make work life more enjoyable. We believe in empowering employees by tackling the daily hurdles that hinder productivity and
          offering them time to do their actual work.
        </p>
      </PurpleGradientContainer>
    </div>
  );
});
AboutUsShowcase.displayName = 'AboutUsShowcase';
export default AboutUsShowcase;
